import {IVaultPasswordPolicy, Order, TranslationsTypes} from '@app/models';
import { IVaultItem } from '@app/pages/passwordManager/interfaces';

export const isNameUnique = (name: string, allVaults: IVaultItem[]) => allVaults.findIndex((vault) => vault.displayName === name) === -1;

export const getDisplayNameError = (name: string, allVaults: IVaultItem[]) => {
    let errorString: TranslationsTypes = '';

    if (name && !isNameUnique(name, allVaults)) {
        errorString = 'VAULT_NAME_UNIQUENESS_ERROR';
    } else if (!name) {
        errorString = 'REQUIRED_FIELD';
    }

    return errorString;
};

export const getDefaultPolicy = (values: IVaultPasswordPolicy[]) => {
    // don't have default policy yet

    // set the default in the dropdown to the default policy
    // const defaultPolicy: IVaultPasswordPolicyDTO = values.filter((item) => item.IsDefault)[0];
    const defaultPolicy = values[0];

    return defaultPolicy?.id;
};

export const sortObjectsByDisplayName = (objects: any[], ascending: Order) => {
    return [...objects].sort((a, b) => {
        if (ascending === Order.asc) {
            return a.displayName.localeCompare(b.displayName);
        } else {
            return b.displayName.localeCompare(a.displayName);
        }
    });
};
